module.exports = __webpack_public_path__ + "static/media/grey.c02c6259.svg";